// doctorHelpers.js
const apiBaseUrl = process.env.REACT_APP_IMAGE_URL;
export const createDoctorsArray = (doctorList) =>
    doctorList?.map((doctor) => {
        const profileSignedUrl = doctor.profileSignedUrl;
        const photoUrl = profileSignedUrl
            ? profileSignedUrl.includes('http')
                ? profileSignedUrl
                : `${apiBaseUrl}${profileSignedUrl}`
            : null;

        return {
            doctorInfo: {
                name: `${doctor.firstName} ${doctor.lastName}, ${doctor.credential}`,
                specialization: doctor.specialtyName,
                address: doctor.surgeryCenterName,
                rating: doctor.overAllAvgReview ? `${doctor.overAllAvgReview?.toFixed(1)}` : '',
                photo: photoUrl,
                firstName: doctor.firstName,
                lastName: doctor.lastName,
                latitude: doctor.latitude,
                longitude: doctor.longitude,
                total: doctor.total,
                fkUserId: doctor.fkUserId,
                credential: doctor.credential,
                organizationName: doctor.organizationName,
                startDate: doctor.startDate,
                cityName: doctor?.cityName || null,
                stateName: doctor?.stateName || null,
                endDate: doctor.endDate,
                totalReview: doctor.totalReview,
                overAllAvgReview: doctor.overAllAvgReview,
                gender: doctor.gender || 'Male', // Default to 'Male' if gender is missing
            },
        };
    });
